//user reducer types
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED'
export const SET_USER = 'SET_USER'
export const LOADING_USER = 'LOADING_USER'
export const MARK_NOTIFICATIONS_READ = 'MARK_NOTIFICATIONS_READ'

//UI reducer types
export const SET_ERRORS = 'SET_ERRORS'
export const LOADING_UI = 'LOADING_UI'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const LOADING_DATA = 'LOADING_DATA'
export const STOP_LOADING_UI = 'STOP_LOADING_UI'

//Data reducer types
export const SET_OPINIONS = 'SET_OPINIONS'
export const SET_OPINION = 'SET_OPINION'
export const HATE_OPINION = 'HATE_OPINION'
export const UNHATE_OPINION = 'UNHATE_OPINION'
export const IGNORE_OPINION = 'IGNORE_OPINION'
export const UNIGNORE_OPINION = 'UNIGNORE_OPINION'
export const DELETE_OPINION = 'DELETE_OPINION'
export const POST_OPINION = 'POST_OPINION'
export const SUBMIT_WRECK = 'SUBMIT_WRECK'
